import { FC } from "react";
import { IconPropsType } from ".";

export const DragHolder: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="5.50098" cy="2.5" r="1.5" fill={props.color} />
      <circle cx="5.50098" cy="7.5" r="1.5" fill={props.color} />
      <circle cx="5.50098" cy="12.5" r="1.5" fill={props.color} />
      <circle cx="10.501" cy="2.5" r="1.5" fill={props.color} />
      <circle cx="10.501" cy="7.5" r="1.5" fill={props.color} />
      <circle cx="10.501" cy="12.5" r="1.5" fill={props.color} />
    </svg>
  );
};
